import { render, staticRenderFns } from "./DocumentLayout.vue?vue&type=template&id=6786acf0&scoped=true"
import script from "./DocumentLayout.vue?vue&type=script&lang=js"
export * from "./DocumentLayout.vue?vue&type=script&lang=js"
import style0 from "./DocumentLayout.vue?vue&type=style&index=0&id=6786acf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6786acf0",
  null
  
)

export default component.exports